import { styled } from '@classify/react-core-components/styles';
import Hyperlink from '@classify/react-core-components/Hyperlink';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import usePromotionProps from './usePromotionProps';

const Root = styled('div')(({ theme: { spacing, palette, radius } }) => ({
  borderRadius: radius.menu,
  background: palette.notification.info.background,
  margin: spacing(0, 1, 1),
  padding: spacing(1.5),
}));

export default function MenuItemJobPostingPromotion() {
  const promotionProps = usePromotionProps();
  if (!promotionProps) {
    return null;
  }
  return (
    <Root>
      <Typography
        variant="bodySmall"
        component="div"
        dangerouslySetInnerHTML={{
          __html: promotionProps.description,
        }}
      />
      <Box sx={{ marginTop: 2 }}>
        <Hyperlink variant="large" underline="none" {...promotionProps.ctaProps}>
          {promotionProps.ctaLabel}
        </Hyperlink>
      </Box>
    </Root>
  );
}
